import { render, staticRenderFns } from "./AddressModule.vue?vue&type=template&id=3f3a8cb3&"
import script from "./AddressModule.vue?vue&type=script&lang=js&"
export * from "./AddressModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports